import { getStoredMirror } from '../hooks/useAuth';

/**
 * Дизайн-темы кабинетов. Тема выбирается по зеркалу сессии и ставится атрибутом
 * `data-theme` на корень страницы — `index.css` переопределяет в этой области
 * CSS-переменные токенов. `default` — исходный дизайн, своего CSS у него нет.
 *
 * Экран входа — в теме последнего входа на устройстве (`getLoginTheme`), для нового
 * посетителя — `mono`: зеркало известно только из ответа `auth`.
 */
export type ThemeId = 'default' | 'industrial';

/** Зеркала без записи — исходный дизайн. */
const MIRROR_THEMES: Record<string, ThemeId> = {
  om: 'industrial',
};

export function themeForMirror(mirrorId: string): ThemeId {
  return MIRROR_THEMES[mirrorId] ?? 'default';
}

export function getSessionTheme(): ThemeId {
  return themeForMirror(getStoredMirror().id);
}

/** Тема экрана входа: тема кабинета, запомненная на устройстве, или монохром. */
export type LoginTheme = ThemeId | 'mono';

/**
 * Тема последнего входа на этом устройстве. Это настройка устройства, а не сессии:
 * performLogout() её намеренно не чистит — после выхода вход остаётся в теме человека.
 * Хранится только название темы — ни логина, ни зеркала.
 */
const LAST_THEME_KEY = 'portal_last_theme';
const THEME_IDS: readonly ThemeId[] = ['default', 'industrial'];

export function rememberTheme(mirrorId: string): void {
  try {
    localStorage.setItem(LAST_THEME_KEY, themeForMirror(mirrorId));
  } catch {
    /* хранилище недоступно — вход останется монохромным */
  }
}

/** Неизвестное или битое значение — монохром. */
export function getLoginTheme(): LoginTheme {
  try {
    const v = localStorage.getItem(LAST_THEME_KEY);
    return THEME_IDS.includes(v as ThemeId) ? (v as ThemeId) : 'mono';
  } catch {
    return 'mono';
  }
}
